import type {AuthenticationSession} from "@vesta/vos-types/modules/platformLevel/authentication/domain/AuthenticationSession";
import {iso8601DateTimeZodValidator, uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {z as zod} from "zod";

export type {AuthenticationSession};

export type AdminAuthenticationSession = AuthenticationSession;

export type AdminAuthenticationSessionRow = AuthenticationSession & {
    id: string;
};

export const adminAuthenticationSessionValidator = zod.object({
    oidcSessionUid: zod.string(),
    userId: uuidZodValidator.nullable(),
    authenticatedAt: iso8601DateTimeZodValidator.nullable(),
    lastAccessedAt: iso8601DateTimeZodValidator,
    signedInIpAddress: zod.string().nullable(),
    lastSeenIpAddress: zod.string().nullable(),
    signedInUserAgent: zod.string().nullable(),
    lastSeenUserAgent: zod.string().nullable(),
    terminatedAt: iso8601DateTimeZodValidator.nullable(),
    createdAt: iso8601DateTimeZodValidator,
    updatedAt: iso8601DateTimeZodValidator,
});

export const adminAuthenticationSessionRowValidator = adminAuthenticationSessionValidator.extend({
    id: zod.string(),
});

export type AdminAuthenticationSessionListRow = AdminAuthenticationSessionRow & {
    name: string | null;
    email: string | null;
    phoneNumber: string | null;
};

export const adminAuthenticationSessionListRowValidator = adminAuthenticationSessionRowValidator.extend({
    name: zod.string().nullable(),
    email: zod.string().nullable(),
    phoneNumber: zod.string().nullable(),
});
